import React, { useState, useEffect } from 'react';
import './colibrateTable.css';
import axiosInstance from '../../../utils/router/axiosInstance';
import { logger } from '../../../utils/logger';

const ColibrateTable = ({ data, onDataChange, building, floor }) => {
  const [tableData, setTableData] = useState(data);
  const [selectedItems, setSelectedItems] = useState([]);
  const [buildings, setBuildings] = useState([]);

  useEffect(() => {
    setTableData(data);
  }, [data]);

  useEffect(() => {
    const fetchBuildings = async () => {
      try {
        const response = await axiosInstance.get('/website/buildings');
        setBuildings(response.data);
      } catch (error) {
        logger.error('Error fetching buildings:', error);
      }
    };
    fetchBuildings();
  }, []);

  const handleDataChange = (index, key, value) => {
    const updatedData = [...tableData];
    updatedData[index][key] = value;
    setTableData(updatedData);
  };

  const handleCheckboxChange = (item, isChecked) => {
    if (isChecked) {
      setSelectedItems([...selectedItems, item]);
    } else {
      setSelectedItems(selectedItems.filter((selectedItem) => selectedItem.bssid !== item.bssid));
    }
    onDataChange(selectedItems);
  };

  useEffect(() => {
    onDataChange(selectedItems);
  }, [selectedItems]);

  return (
    <div className="table-container-colibrate">
      <table>
        <thead>
          <tr>
            <th></th>
            <th>Название</th>
            <th>BSSID</th>
            <th>X</th>
            <th>Y</th>
            <th>Этаж</th>
            <th>Здание</th>
            <th>N</th>
            <th>А</th>
          </tr>
        </thead>
        <tbody>
          {tableData
            .filter((item) => {
              if (building && floor) {
                return item.building_id === building.id && item.floor === parseInt(floor);
              }
              return true;
            })
            .map((item, index) => {
              const buildingName = buildings.find((b) => b.id === item.building_id)?.name || '';
              return (
                <tr key={index}>
                  <td>
                    <input type="checkbox" onChange={(e) => handleCheckboxChange(item, e.target.checked)} />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={item.ssid}
                      onChange={(e) => handleDataChange(index, 'ssid', e.target.value)}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={item.bssid}
                      onChange={(e) => handleDataChange(index, 'bssid', e.target.value)}
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      value={item.x}
                      onChange={(e) => handleDataChange(index, 'x', e.target.value)}
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      value={item.y}
                      onChange={(e) => handleDataChange(index, 'y', e.target.value)}
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      value={item.floor}
                      onChange={(e) => handleDataChange(index, 'floor', e.target.value)}
                    />
                  </td>
                  <td>{buildingName}</td>
                  <td>
                    <input
                      type="number"
                      value={item.n}
                      onChange={(e) => handleDataChange(index, 'n', e.target.value)}
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      value={item.A}
                      onChange={(e) => handleDataChange(index, 'A', e.target.value)}
                    />
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};

export default ColibrateTable;
